import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ClimatisationPage from "../pages/services/climatisation/page";
import ChauffagePage from "../pages/services/chauffage/page";
import PlomberiePage from "../pages/services/plomberie/page";
import RenovationSalleDeBainsPage from "../pages/services/renovation-salle-de-bains/page";
import DepannageUrgentPage from "../pages/services/depannage-urgent/page";
import EntretienPage from "../pages/services/entretien/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services/climatisation",
    element: <ClimatisationPage />,
  },
  {
    path: "/services/chauffage",
    element: <ChauffagePage />,
  },
  {
    path: "/services/plomberie",
    element: <PlomberiePage />,
  },
  {
    path: "/services/renovation-salle-de-bains",
    element: <RenovationSalleDeBainsPage />,
  },
  {
    path: "/services/depannage-urgent",
    element: <DepannageUrgentPage />,
  },
  {
    path: "/services/entretien",
    element: <EntretienPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;